<script lang="ts">
import Icon from '../../../Icon/Icon.vue';
import { highlight } from '../../utils/highlight';

export type Hit = {
  id: string;
  label: string;
};

type Props = {
  cursorIndex?: number;
  searchPhrase?: string;
  items: Hit[];
};
</script>

<script setup lang="ts">
defineProps<Props>();

const emit = defineEmits(['click']);
</script>

<template>
  <div :class="$style.container">
    <div
      v-for="({ label, id }, index) in items"
      :key="id"
      :class="[$style.item, cursorIndex === index && $style.focus]"
      @click="emit('click', label)"
    >
      <div :class="$style.label" v-html="highlight(label, searchPhrase)" />
      <Icon :class="$style.icon" name="arrow_forward" />
    </div>
  </div>
</template>

<style module lang="scss" src="./Hits.scss" />
